import React, { useEffect, useRef } from "react";

const CanvasBackground = () => {
  const canvasRef = useRef(null);

  // useEffect(() => {
  //   const canvas = canvasRef.current;
  //   const ctx = canvas.getContext("2d");

  //   // Target the first two sections
  //   const targetElement = document.querySelector(".animated-sections");
  //   const { width, height, top, left } = targetElement.getBoundingClientRect();

  //   canvas.width = width;
  //   canvas.height = height;

  //   canvas.style.position = "absolute";
  //   canvas.style.top = `${top + window.scrollY}px`;
  //   canvas.style.left = `${left}px`;

  //   // Define circles
  //   const circles = Array.from({ length: 100 }).map(() => ({
  //     x: Math.random() * canvas.width,
  //     y: Math.random() * canvas.height,
  //     radius: Math.random() * 0.001 + 1, // Smaller circles: 1px to 2px
  //     dx: (Math.random() - 0.5) * 0.5,
  //     dy: (Math.random() - 0.5) * 0.5,
  //   }));

  //   const animate = () => {
  //     ctx.clearRect(0, 0, canvas.width, canvas.height);

  //     circles.forEach((circle) => {
  //       ctx.beginPath();
  //       ctx.arc(circle.x, circle.y, circle.radius, 0, Math.PI * 2, false);
  //       ctx.fillStyle = "#FE7201FF"; // Circle color
  //       ctx.fill();

  //       // Move circles
  //       circle.x += circle.dx;
  //       circle.y += circle.dy;

  //       // Wrap around edges
  //       if (circle.x > canvas.width) circle.x = 0;
  //       if (circle.x < 0) circle.x = canvas.width;
  //       if (circle.y > canvas.height) circle.y = 0;
  //       if (circle.y < 0) circle.y = canvas.height;
  //     });

  //     requestAnimationFrame(animate);
  //   };

  //   animate();

  //   // Update on resize
  //   const handleResize = () => {
  //     const { width, height, top, left } = targetElement.getBoundingClientRect();
  //     canvas.width = width;
  //     canvas.height = height;
  //     canvas.style.top = `${top + window.scrollY}px`;
  //     canvas.style.left = `${left}px`;
  //   };
  //   window.addEventListener("resize", handleResize);

  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, []);


  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // Target the first two sections
    const targetElement = document.querySelector(".animated-sections");
    const { width, height, top, left } = targetElement.getBoundingClientRect();

    // Set initial canvas size and position
    canvas.width = Math.min(width, window.innerWidth);
    canvas.height = Math.min(height, window.innerHeight);

    canvas.style.position = "absolute";
    canvas.style.top = `${top + window.scrollY}px`;
    canvas.style.left = `${left}px`;
    canvas.style.maxWidth = "100%"; // Restrict canvas to viewport width
    canvas.style.maxHeight = "100%"; // Restrict canvas to viewport height
    canvas.style.overflow = "hidden";

    // Define circles
    const circles = Array.from({ length: 100 }).map(() => ({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      radius: Math.random() * 0.001 + 1, // Smaller circles: 1px to 2px
      dx: (Math.random() - 0.5) * 0.5,
      dy: (Math.random() - 0.5) * 0.5,
    }));

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      circles.forEach((circle) => {
        ctx.beginPath();
        ctx.arc(circle.x, circle.y, circle.radius, 0, Math.PI * 2, false);
        ctx.fillStyle = "#FE7201FF"; // Circle color
        ctx.fill();

        // Move circles
        circle.x += circle.dx;
        circle.y += circle.dy;

        // Wrap around edges
        if (circle.x > canvas.width) circle.x = 0;
        if (circle.x < 0) circle.x = canvas.width;
        if (circle.y > canvas.height) circle.y = 0;
        if (circle.y < 0) circle.y = canvas.height;
      });

      requestAnimationFrame(animate);
    };

    animate();

    // Update on resize
    const handleResize = () => {
      const { width, height, top, left } = targetElement.getBoundingClientRect();

      // Restrict canvas size to the viewport dimensions
      canvas.width = Math.min(width, window.innerWidth);
      canvas.height = Math.min(height, window.innerHeight);

      canvas.style.top = `${top + window.scrollY}px`;
      canvas.style.left = `${left}px`;
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);



  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "absolute",
        zIndex: -1,
        pointerEvents: "none",
      }}
    />
  );
};

export default CanvasBackground;
